export const AUTH_TOKEN_KEY = "theqahub_auth_token";

export const getAuthHeader = () => {
  if (typeof window === "undefined") return {};
  try {
    // Cleanup legacy bearer tokens now that auth is cookie-only.
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch {
    // noop
  }
  return {};
};

export const storeAuthToken = () => {
  try {
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch {}
};

export const clearAuthToken = () => {
  try {
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch {}
};
